<template>
  <transition name="toast-fade">
    <div
      v-if="toast.isShow"
      role="status"
      aria-live="polite"
      :class="[
        'toast',
        `toast--${position}`,
        'flex items-start gap-3 rounded-cyma-md px-4 py-3 ring-1 ring-white/55 shadow-[0_12px_32px_rgba(76,23,96,0.16)] backdrop-blur-xl',
        accentClass,
      ]"
    >
      <span
        :class="['mt-0.5 h-2.5 w-2.5 flex-shrink-0 rounded-full', dotClass]"
        aria-hidden="true"
      ></span>

      <p class="flex-1 text-sm font-medium text-cyma-gray">
        {{ toast.message }}
      </p>

      <button
        class="-mr-1 flex-shrink-0 text-cyma-gray/50 transition hover:text-cyma-gray"
        aria-label="Cerrar notificación"
        @click="close"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
        </svg>
      </button>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useToastStore } from "@/stores/toast.store";

defineOptions({ name: "GlassToast" });

const toast = useToastStore();

const position = computed(() => toast.configs.position);

const accentClass = computed(
  () =>
    ({
      success: "border-l-4 border-l-emerald-500",
      error: "border-l-4 border-l-red-500",
      warning: "border-l-4 border-l-amber-500",
      info: "border-l-4 border-l-cyma-purple",
    }[toast.type] ?? "border-l-4 border-l-cyma-purple")
);

const dotClass = computed(
  () =>
    ({
      success: "bg-emerald-500",
      error: "bg-red-500",
      warning: "bg-amber-500",
      info: "bg-cyma-purple",
    }[toast.type] ?? "bg-cyma-purple")
);

const close = () => {
  toast.hideToast();
};
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  z-index: 9999;
  width: max-content;
  max-width: min(420px, calc(100vw - 2rem));
  background-color: rgba(255, 255, 255, 0.92);

  &--top-center {
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
  }
  &--top-right {
    top: 1rem;
    right: 1rem;
  }
  &--top-left {
    top: 1rem;
    left: 1rem;
  }
  &--bottom-center {
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
  }
  &--bottom-right {
    bottom: 1rem;
    right: 1rem;
  }
  &--bottom-left {
    bottom: 1rem;
    left: 1rem;
  }
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
.toast--top-center.toast-fade-enter-from,
.toast--top-center.toast-fade-leave-to,
.toast--bottom-center.toast-fade-enter-from,
.toast--bottom-center.toast-fade-leave-to {
  transform: translateX(-50%) translateY(-8px);
}
</style>
